/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApplicantSignaturesService {

    /**
     * List applicant signatures
     * Returns signed document signatures for the specified applicant.
     * @param applicantExternalId Applicant external ID
     * @param xAccessToken
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiWxApplicantsSignatures(
        applicantExternalId: string,
        xAccessToken: string,
    ): CancelablePromise<{
        signatures: Array<{
            signed_at: string | null;
            file_url: string | null;
            title: string | null;
            template: {
                id?: number;
                title?: string;
                message?: string;
                template_id?: string;
                provider?: string;
                signer_roles?: Array<any>;
                created_at?: string;
                updated_at?: string;
            } | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/applicants/{applicant_external_id}/signatures',
            path: {
                'applicant_external_id': applicantExternalId,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
                404: `not found`,
            },
        });
    }

}